import { Component, computed, inject } from '@angular/core';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { QuestionOption, QuestionType } from '@empathy/survey/base';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-question-options-dropdown',
  templateUrl: './question-options-dropdown.component.html',
  styleUrls: ['./question-options-dropdown.component.scss']
})
export class QuestionOptionsDropdownComponent {
  faClose = faClose;
  options$ = computed(() => this.getOptions());

  surveyConditionalsService = inject(SurveyConditionalsService);

  onClearSelectedOption(): void {
    this.surveyConditionalsService.conditionForm$().get('optionId').reset();
    this.surveyConditionalsService.conditionForm$().get('operator').reset();
    this.surveyConditionalsService.conditionForm$().get('valueToMatch').reset();
  }

  private getOptions(): QuestionOption[] {
    const opt = [...this.surveyConditionalsService.questionSelected$().options];
    if (this.surveyConditionalsService.questionSelected$().type === QuestionType.RankSort) {
      if (this.surveyConditionalsService.questionSelected$().useOtherInd) {
        opt.push({
          id: 'OTHER',
          exclusiveInd: true,
          pinnedPositionInd: false,
          value: 'OTHER',
          text: 'Other',
          stimulus: null,
          visibleWhen: [],
          selectedWhen: [],
          visible: false
        });
      }

      if (this.surveyConditionalsService.questionSelected$().useNoneInd) {
        opt.push({
          id: 'NONE',
          exclusiveInd: false,
          pinnedPositionInd: false,
          value: 'NONE',
          text: this.surveyConditionalsService.questionSelected$().noneLabel,
          stimulus: null,
          visibleWhen: [],
          selectedWhen: [],
          visible: false
        });
      }
    }

    return opt;
  }
}
